<template>
  <v-stepper v-model="e1" class="elevation-0">
    <v-stepper-header>
      <v-stepper-step :editable="true" @click="resetAccount" :complete="e1 > 1" step="1">
        {{ this.$t('steps.one.title') }}
        <small v-if="account !== undefined">{{ account.client_id }}</small>
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" :rules="[() => account.status == 'connected' || e1 == 1]" step="2">
        {{ this.$t('steps.two.title') }}
        <small v-if="account.status == 'pending'">{{ this.$t('steps.two.not_connected') }}</small>
        <small v-if="account.status == 'connected'">{{ this.$t('steps.two.connected') }}</small>
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :editable="e1 >= 4" @click="resetSelection" :complete="e1 > 3" step="3">
        {{ this.$t('steps.three.title') }}
        <small v-if="reportrequest.start !== undefined && reportrequest.end !== undefined && e1 >= 4">{{ formatTimeRangeDate(reportrequest.start) + ' - ' + formatTimeRangeDate(reportrequest.end) }}</small>
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4" :complete="e1 > 4" >{{ this.$t('steps.four.title') }}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="5">{{ this.$t('steps.five.title') }}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          class="mb-12"
          height="200px"
          :flat="true"
        >
          <v-row>
            <v-col :cols="3" class="pt-0">
              <v-alert v-if="$env === 'dev'" type="info">Valid Account: 1006309186 - Invalid/Pending Account: 1234567890</v-alert>
              <v-text-field :label="'Account Id'" v-model="clientId"></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-btn
          color="primary"
          :loading="createAccountBtnLoading"
          :disabled="createAccountBtnLoading"
          @click="createAccount"
        >
          Weiter
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card
          class="mb-12"
          height="200px"
          :flat="true"
        >
          <v-row>
            <v-col :cols="6">
              <v-alert width="fit-content" border="left" type="error">Account ist noch nicht verknüpft.</v-alert>
            </v-col>
          </v-row>
        </v-card>
        <v-btn
          color="primary"
          :loading="checkAccountBtnLoading"
          :disabled="checkAccountBtnLoading"
          @click="checkAccount"
        >
          Erneut prüfen
        </v-btn>
        <v-btn text @click="resetAccount">Abbrechen</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3" overflow-hidden>
        <v-row>
          <v-col :cols="4" class="pt-0 full-height">
            <v-tabs v-model="activeTabHeader" color="primary">
              <v-tabs-slider></v-tabs-slider>
              <v-tab :key="'tabKPI'" @click="activeTab='tabKPI'" :tabindex="0">KPI</v-tab>
              <v-tab :key="'tabConversionTargets'" @click="activeTab='tabConversionTargets'" :tabindex="1">Conversion Targets</v-tab>
            </v-tabs>
            <v-tabs-items v-model="activeTab">
              <v-tab-item :key="'tabKPI'" :value="'tabKPI'" class="pl-1 pt-6 pr-6 pb-6">

                <v-card
                class="mx-auto mb-4"
                color="white"
                max-width="640"
                min-height="192"
                >
                  <v-card-title>
                    <v-icon color="primary" size="32">
                      mouse
                    </v-icon>
                    &nbsp;Clicks
                  </v-card-title>
                  <v-sheet color="transparent">
                    <v-container fill-height v-if="kpiChartsLoading">
                      <v-layout row justify-center align-center>
                        <v-progress-circular
                          :size="24"
                          :width="3"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </v-layout>
                    </v-container>
                    <v-sparkline
                      v-else
                      :value="dataClicksChart"
                      :labels="dataLabels"
                      color="primary"
                      line-width="2"
                      auto-draw
                      bar
                      class="mx-4"
                      style="overflow: visible"
                    >
                    </v-sparkline>
                  </v-sheet>
                </v-card>

                <v-spacer></v-spacer>

                <v-card
                class="mx-auto mb-4"
                color="white"
                max-width="640"
                min-height="192"
                >
                  <v-card-title>
                    <v-icon color="primary" size="32">
                      euro
                    </v-icon>
                    &nbsp;Cost
                  </v-card-title>
                  <v-sheet color="transparent">
                    <v-container fill-height v-if="kpiChartsLoading">
                      <v-layout row justify-center align-center>
                        <v-progress-circular
                          :size="24"
                          :width="3"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </v-layout>
                    </v-container>
                    <v-sparkline
                      v-else
                      :value="dataCostChart"
                      :labels="dataLabels"
                      color="primary"
                      line-width="2"
                      auto-draw
                      bar
                      class="mx-4"
                      style="overflow: visible"
                    >
                    </v-sparkline>
                  </v-sheet>
                </v-card>

                <v-spacer></v-spacer>

                <v-card
                class="mx-auto"
                color="white"
                max-width="640"
                min-height="192"
                >
                  <v-card-title>
                    <v-icon color="primary" size="32">
                      cached
                    </v-icon>
                    &nbsp;Conversions
                  </v-card-title>
                  <v-sheet color="transparent">
                    <v-container fill-height v-if="kpiChartsLoading">
                      <v-layout row justify-center align-center>
                        <v-progress-circular
                          :size="24"
                          :width="3"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </v-layout>
                    </v-container>
                    <v-sparkline
                      v-else
                      :value="dataConversionsChart"
                      :labels="dataLabels"
                      color="primary"
                      line-width="2"
                      auto-draw
                      bar
                      class="mx-4"
                      style="overflow: visible"
                    >
                    </v-sparkline>
                  </v-sheet>
                </v-card>
                <v-spacer></v-spacer>

              </v-tab-item>
              <v-tab-item :key="'tabConversionTargets'" :value="'tabConversionTargets'" class="pt-1">
                <v-simple-table
                  overflow-scroll-y
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th v-for="header in dataLabelConversions" :key="header['@name']" class="text-left">
                          {{ header['@display'] }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in dataConversions" :key="index">
                        <td v-for="header in dataLabelConversions" :key="index + header['@name']">
                          {{ row['@' + header['@name']] }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col :cols="4" class="pt-0 full-height">
            <v-card
              class="mb-12"
              height="250px"
              :flat="true"
            >
              <v-col :cols="9">
                <div class="subtitle-1 mb-4">Neue Auswertung</div>
                <v-menu
                  v-model="fromDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Von"
                      prepend-icon="event"
                      readonly
                      :value="fromDateDisp"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    v-model="fromDateVal"
                    :no-title="true"
                    @input="fromDateMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="toDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Bis"
                      prepend-icon="event"
                      readonly
                      :value="toDateDisp"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    v-model="toDateVal"
                    :no-title="true"
                    @input="toDateMenu = false"
                  ></v-date-picker>
                </v-menu>
                <v-spacer class="mb-8"></v-spacer>
                <v-btn
                  color="primary"
                  :loading="createReportRequestBtnLoading"
                  :disabled="createReportRequestBtnDisabled"
                  @click="newReportRequest"
                  class="ml-8"
                >
                  Auswertung erstellen
                </v-btn>
              </v-col>
            </v-card>
          </v-col>
          <v-col :cols="4" class="full-height">
            <v-card
              class="mb-12"
              height="550px"
              :flat="true"
              color="gray"
            >
              <div class="subtitle-1">Auswertungen</div>
              <template>
                <v-list>
                  <v-data-iterator
                  content-tag="v-layout"
                  content-props="row wrap"
                  :loading="reportRequestsLoading"
                  :items="reportrequests"
                  :items-per-page.sync="reportRequestsPerPage"
                  :sort-by="reportRequestsSortBy"
                  :sort-desc="true"
                  no-data-text="Keine Auswertungen vorhanden.">
                    <template slot="loading">
                      <v-layout row justify-center align-center>
                        <v-progress-circular
                          :size="24"
                          :width="3"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                    <template slot="no-data">
                      <v-layout row justify-center align-center class="mt-8">
                      Keine Auswertungen vorhanden.
                      </v-layout>
                    </template>
                    <v-list-item slot="item" slot-scope="props">
                      <v-list-item-icon>
                        <v-icon v-text="reportRequestIcon(props.item.status)"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="'Erstellt: ' + formatDate(props.item.created)"></v-list-item-title>
                        <v-list-item-subtitle v-text="formatTimeRangeDate(props.item.start) + ' - ' + formatTimeRangeDate(props.item.end)"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="props.item.status === 'completed'" @click="showReportRequest(props.item.id)">
                        <v-btn icon>
                          <v-icon color="primary">forward</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <v-list-item-action v-if="props.item.status === 'pending' || props.item.status === 'processing'">
                        <v-progress-circular
                            :size="24"
                            :width="3"
                            color="primary"
                            indeterminate
                          ></v-progress-circular>
                      </v-list-item-action>
                    </v-list-item>
                  </v-data-iterator>
                </v-list>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card
          class="mb-12"
          :flat="true"
        >
          <v-layout style="min-height: 64px">
            <v-col :cols="10" class="pt-0">
                <v-layout row align-start >
                  <v-alert
                    v-for="item in selected"
                    :key="item.id"
                    @input="onKeywordDismiss(item.id)"
                    width="fit-content"
                    dense
                    color="primary"
                    dismissible
                    dark
                    border="left"
                    class="d-flex mr-1 caption"
                  >
                    <span>{{ item.Criteria }}</span>
                  </v-alert>
                </v-layout>
            </v-col>
            <v-col :cols="2" class="pt-0 text-right">
              <v-btn
                :tooltip="'Reports erstellen und herunterladen'"
                :disabled="btnDownloadDisabled"
                color="primary"
                large
                @click="onDownload"
              >
                Weiter
              </v-btn>
            </v-col>
           </v-layout>

          <v-row>
            <v-col>
              <v-data-table
                v-model="selected"
                :items="items"
                :single-select="singleSelect"
                :headers="headers"
                :footer-props="{
                  'items-per-page-options': [25]
                }"
                :dense="true"
                :server-items-length="total"
                :options.sync="options"
                :hide-default-footer="true"
                :loading="tableLoading"
                :no-results-text="$t('global.datatable.noMatchingResults')"
                :no-data-text="$t('global.datatable.noDataAvailable')"
                item-key="id"
                show-select
                style="white-space: nowrap;"
                @update:sort-desc="onSort"
              >
                <!-- modify view data -->
                <template v-slot:item.CpcBid="{ item }">
                  <span>{{ convertCpcBid(item.CpcBid) }}</span>
                </template>
                <template v-slot:item.AverageCpc="{ item }">
                  <span>{{ convertMoneyType(item.AverageCpc) }} {{ item.AccountCurrencyCode }}</span>
                </template>
                <template v-slot:item.Cost="{ item }">
                  <span>{{ convertMoneyType(item.Cost) }} {{ item.AccountCurrencyCode }}</span>
                </template>
                <template v-slot:item.CostPerConversion="{ item }">
                  <span>{{ convertMoneyType(item.CostPerConversion) }} {{ item.AccountCurrencyCode }}</span>
                </template>
                <template v-slot:item.ConversionRate="{ item }">
                  <span>{{ convertPercentType(item.ConversionRate) }}</span>
                </template>
                <template v-slot:item.SearchImpressionShare="{ item }">
                  <span>{{ convertPercentType(item.SearchImpressionShare) }}</span>
                </template>
                <template v-slot:item.SearchRankLostImpressionShare="{ item }">
                  <span>{{ convertPercentType(item.SearchRankLostImpressionShare) }}</span>
                </template>
                <template v-slot:item.Ctr="{ item }">
                  <span>{{ convertPercentType(item.Ctr) }}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="5">
        <v-row>
          <v-col :cols="2" class="pt-0 text-left">
            <v-btn text @click="e1 = 4">
              Zurück zur Auswahl
            </v-btn>
          </v-col>

          <v-col :cols="8" class="pt-0">
            <v-layout align-start justify-center>

              <v-flex xs8>
                <v-card
                  class="mb-12 elevation-1"
                  :flat="true"
                >
                  <!-- <v-data-iterator
                    content-tag="v-layout"
                    content-props="row wrap"
                    :items="selected"
                    :sort-by="selectedSortBy"
                    :sort-desc="selectedSortDesc"
                    disable-pagination
                    hide-default-footer
                    >
                    <template slot="header">
                      <v-toolbar
                        color="grey darken-1"
                        dark
                        flat
                      >
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                          <v-select
                            v-model="selectedSortBy"
                            flat
                            solo-inverted
                            hide-details
                            :items="selectedSortKeys"
                            prepend-inner-icon="search"
                            label="Sortieren nach"
                          ></v-select>
                          <v-spacer></v-spacer>
                          <v-btn-toggle dense tile borderless color="white" v-model="selectedSortDesc" mandatory>
                            <v-btn depressed color="grey darken-1" :value="false">
                              <v-icon color="white">arrow_upward</v-icon>
                            </v-btn>
                            <v-btn depressed color="grey darken-1" :value="true">
                              <v-icon color="white">arrow_downward</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </template>
                      </v-toolbar>
                    </template>

                    <template slot="default" slot-scope="props">
                      <v-list>
                        <v-list-item-group>
                          <draggable v-model="props.items" ghost-class="ghost" @start="drag=true" @end="drag=false">
                            <transition-group type="transition" name="flip-list">
                              <template v-for="(item, index) in props.items" :id="item.id">
                                <v-divider v-if="index > 0" :key="index"></v-divider>
                                <v-list-item dense :key="item.id" :id="item.id" class="sortable" style="max-height: 54px;">
                                  <v-list-item-icon>
                                    <v-chip color="primary" v-text="index+1"></v-chip>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <span>{{ item.Criteria + ' - ' + item.CampaignName }}</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      <span>Clicks: {{ item.Clicks }}</span>&nbsp;|
                                      <span>Cost: {{ convertMoneyType(item.Cost) }}</span>&nbsp;|
                                      <span>Conversions: {{ item.Conversions }}</span>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </transition-group>
                          </draggable>
                        </v-list-item-group>
                      </v-list>
                    </template>

                  </v-data-iterator> -->

                  <!-- <v-data-iterator
                    content-tag="v-layout"
                    content-props="row wrap"
                    :items="selected"
                    :sort-by="selectedSortBy"
                    :sort-desc="selectedSortDesc"
                    disable-pagination
                    hide-default-footer
                    disable-sort="true"
                    >
                    <template slot="header">
                      <v-toolbar
                        color="grey darken-1"
                        dark
                        flat
                      >
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                          <v-select
                            v-model="selectedSortBy"
                            flat
                            solo-inverted
                            hide-details
                            :items="selectedSortKeys"
                            prepend-inner-icon="search"
                            label="Sortieren nach"
                          ></v-select>
                          <v-spacer></v-spacer>
                          <v-btn-toggle dense tile borderless color="white" v-model="selectedSortDesc" mandatory>
                            <v-btn depressed color="grey darken-1" :value="false">
                              <v-icon color="white">arrow_upward</v-icon>
                            </v-btn>
                            <v-btn depressed color="grey darken-1" :value="true">
                              <v-icon color="white">arrow_downward</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </template>
                      </v-toolbar>
                    </template>

                    <template slot="default" slot-scope="props">
                      <v-list>
                        <v-list-item-group>
                          <draggable v-model="props.items" ghost-class="ghost" @start="drag=true" @end="drag=false">
                            <v-list-item v-for="(item, index) in props.items" dense :key="'li'+index" :id="index" class="sortable" style="max-height: 54px;">
                              <v-list-item-icon>
                                <v-chip color="primary" v-text="index+1"></v-chip>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span>{{ item.Criteria + ' - ' + item.CampaignName }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <span>Clicks: {{ item.Clicks }}</span>&nbsp;|
                                  <span>Cost: {{ convertMoneyType(item.Cost) }}</span>&nbsp;|
                                  <span>Conversions: {{ item.Conversions }}</span>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </draggable>
                        </v-list-item-group>
                      </v-list>
                    </template>

                  </v-data-iterator> -->

                  <v-list>
                    <v-list-item-group>
                      <draggable v-model="selected" ghost-class="ghost" @start="drag=true" @end="drag=false">
                        <v-list-item v-for="(item, index) in selected" dense :key="'li'+index" :id="index" class="sortable" style="max-height: 54px;">
                          <v-list-item-icon>
                            <v-chip color="primary" v-text="index+1"></v-chip>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span>{{ item.Criteria + ' - ' + item.CampaignName }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span>Clicks (Prd.): {{ item.Clicks }} ({{ item.predicted_increase_clicks }})</span>&nbsp;|
                              <span>Cost: {{ convertMoneyType(item.Cost) }} {{ item.AccountCurrencyCode }}</span>&nbsp;|
                              <span>Conversions (Prd.): {{ item.Conversions }} ({{ item.predicted_increase_conversions }})</span>&nbsp;|
                              <span>AverageCpc (Prd.): {{ convertMoneyType(item.AverageCpc) }} ({{ item.predicted_decrease_cpc }})</span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </draggable>
                    </v-list-item-group>
                  </v-list>

                </v-card>
              </v-flex>
            </v-layout>
          </v-col>

          <v-col :cols="2" class="pt-0 text-right">
            <v-btn
              color="primary"
              @click="createReport"
              :loading="createReportBtnLoading"
              :disabled="createReportBtnLoading"
            >
              Report erstellen
            </v-btn>
          </v-col>
        </v-row>

      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>

import {
  mapMutations,
} from 'vuex'
import LocalesMixin from './mixins/locales'
import { Auth, API, graphqlOperation } from 'aws-amplify'
import {
  getAdWordsAccount,
  getAdWordsReportRequest,
  listAdWordsReportRequests,
  getAdWordsAccountKpiReport,
  getAdWordsAccountConversionsReport
} from '@/graphql/queries'
import { createAdWordsAccount, createAdWordsReportRequest } from '@/graphql/mutations'
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  mixins: [
    LocalesMixin,
  ],
  components: {
    draggable
  },
  data () {
    return {
      pageTitle: 'adwords.dashboard',
      e1: 1,
      clientId: undefined,
      account: {},
      reportrequest: {},
      reportrequests: [],
      items: [],
      createAccountBtnLoading: false,
      checkAccountBtnLoading: false,
      createReportRequestBtnLoading: false,
      btnDownloadLoading: false,
      createReportBtnLoading: false,
      fromDateMenu: false,
      fromDateVal: null,
      toDateMenu: false,
      toDateVal: null,
      reportType: 'golden_nuggets',
      activeTabHeader: null,
      activeTab: 'tabKPI',
      dataClicksChart: [],
      dataCostChart: [],
      dataConversionsChart: [],
      kpiChartsLoading: true,
      dataLabels: [],
      conversionsReportLoading: true,
      dataConversionsReport: [],
      dataLabelConversions: [],
      dataConversions: [],
      reportRequestsLoading: false,
      filteredReportRequests: [],
      reportRequestsPerPage: 10,
      reportRequestsSortBy: 'created',
      singleSelect: false,
      selected: [
        // {
        //   id: 135442,
        //   Criteria: "+hgeuoheorg +rhoueh",
        //   CampaignName: "EN/DE/WHATEVER",
        //   CpcBid: 100,
        //   Clicks: 10,
        // },
        // {
        //   id: 135443,
        //   Criteria: "+hgeuoheorg +rhoueh",
        //   CampaignName: "EN/DE/WHATEVER",
        //   CpcBid: 80,
        //   Clicks: 20,
        // },
        // {
        //   id: 635433,
        //   Criteria: "+hg123heorg +rhfeeh",
        //   CampaignName: "EN/DE/WHATEVER",
        //   CpcBid: 900,
        //   Clicks: 5,
        // }
      ],
      headers: [
        // {
        //   text: string
        //   value: string
        //   align?: 'start' | 'center' | 'end'
        //   sortable?: boolean
        //   filterable?: boolean
        //   divider?: boolean
        //   class?: string | string[]
        //   width?: string | number
        //   filter?: (value: any, search: string, item: any) => boolean
        //   sort?: (a: any, b: any) => number
        // },
        {
          text: 'Criteria',
          sortable: false,
          value: 'Criteria',
        },
        {
          text: 'Status',
          sortable: false,
          value: 'Status',
        },
        {
          text: 'CampaignName',
          sortable: false,
          value: 'CampaignName',
        },
        {
          text: 'CampaignStatus',
          sortable: false,
          value: 'CampaignStatus',
        },
        {
          text: 'predicted_decrease_cpc',
          sortable: true,
          value: 'predicted_decrease_cpc',
        },
        {
          text: 'predicted_increase_impressions',
          sortable: true,
          value: 'predicted_increase_impressions',
        },
        {
          text: 'predicted_increase_clicks',
          sortable: true,
          value: 'predicted_increase_clicks',
        },
        {
          text: 'predicted_increase_conversions',
          sortable: true,
          value: 'predicted_increase_conversions',
        },
        {
          text: 'AdGroupName',
          sortable: false,
          value: 'AdGroupName',
        },
        {
          text: 'AccountCurrencyCode',
          sortable: false,
          value: 'AccountCurrencyCode',
        },
        {
          text: 'CpcBid',
          sortable: false,
          value: 'CpcBid',
        },
        {
          text: 'Clicks',
          sortable: false,
          value: 'Clicks',
        },
        {
          text: 'Impressions',
          sortable: false,
          value: 'Impressions',
        },
        {
          text: 'Ctr',
          sortable: false,
          value: 'Ctr',
        },
        {
          text: 'AverageCpc',
          sortable: false,
          value: 'AverageCpc',
        },
        {
          text: 'Cost',
          sortable: false,
          value: 'Cost',
        },
        {
          text: 'Conversions',
          sortable: false,
          value: 'Conversions',
        },
        {
          text: 'ConversionRate',
          sortable: false,
          value: 'ConversionRate',
        },
        {
          text: 'CostPerConversion',
          sortable: false,
          value: 'CostPerConversion',
        },
        {
          text: 'SearchImpressionShare',
          sortable: false,
          value: 'SearchImpressionShare',
        },
        {
          text: 'SearchRankLostImpressionShare',
          sortable: false,
          value: 'SearchRankLostImpressionShare',
        },
        {
          text: 'QualityScore',
          sortable: false,
          value: 'QualityScore',
        },
        {
          text: 'SearchPredictedCtr',
          sortable: false,
          value: 'SearchPredictedCtr',
        },
        {
          text: 'PostClickQualityScore',
          sortable: false,
          value: 'PostClickQualityScore',
        },
        {
          text: 'CreativeQualityScore',
          sortable: false,
          value: 'CreativeQualityScore',
        },
        {
          text: 'uplift_search_predicted_ctr',
          sortable: false,
          value: 'uplift_search_predicted_ctr',
        },
        {
          text: 'uplift_post_click_quality_score',
          sortable: false,
          value: 'uplift_post_click_quality_score',
        },
        {
          text: 'uplift_sum',
          sortable: false,
          value: 'uplift_sum',
        },
      ],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['predicted_increase_conversions'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      total: 25,
      tableLoading: false,
      selectedSortBy: undefined,
      selectedSortKeys: ['Clicks', 'Cost', 'Conversions'],
      selectedSortDesc: [],
      pollingReportRequestList: undefined,
      pollingReportStatus: []
    }
  },
  computed: {
    btnDownloadDisabled() {
      return this.selected.length == 0
    },
    createReportRequestBtnDisabled() {
      return !(this.fromDateVal && this.toDateVal) || this.createReportRequestBtnLoading
    },
    fromDateDisp() {
      if (this.fromDateVal) {
        console.log(this.fromDateVal)
        let year = this.fromDateVal.substring(0, 4)
        let month = this.fromDateVal.substring(5, 7)
        return '01.' + month + '.' + year
      }
    },
    toDateDisp() {
      if (this.toDateVal) {
        console.log(this.toDateVal)
        let year = this.toDateVal.substring(0, 4)
        let month = this.toDateVal.substring(5, 7)
        return this.getLastDayOfMonth(year, month) + '.' + month + '.' + year
      }
    },
  },
  methods: {
    ...mapMutations('app', ['setPage']),
    onKeywordDismiss(id) {
      for (var i = this.selected.length - 1; i >= 0; --i) {
        if (this.selected[i].id == id) {
          this.selected.splice(i,1);
        }
      }
    },
    convertCpcBid(value) {
      if (value) {
        value = value.toString().replace("auto: ", "")
        return this.convertMoneyType(parseFloat(value))
      }
    },
    convertMoneyType(value) {
      value *= 0.000001
      value = Math.round((value + Number.EPSILON) * 100) / 100
      value = value.toString().replace(".", ",")
      if (value === '0') {
        value += ',00'
      }
      return value
    },
    convertPercentType(value) {
      value = Math.round((value + Number.EPSILON) * 100) / 100
      value = value.toString().replace(".", ",")
      return value + '%'
    },
    getLastDayOfMonth(year, month) {
      return  new Date(year, month, 0).getDate()
    },
    // @todo: store data maybe in store to preserve
    resetAccount () {
      this.clientId = undefined
      this.account = {}
      this.reportrequest = {
        report_data: []
      }
      this.reportrequests = []
      this.items = []
      this.selected = []
      this.dataClicksChart = []
      this.dataCostChart = []
      this.dataConversionsChart = []
      this.dataLabels = []
      this.dataLabelConversions = []
      this.dataConversions = []
      clearInterval(this.pollingReportRequestList)
      this.fromDateMenu = false
      this.fromDateVal = null
      this.toDateMenu = false
      this.toDateVal = null
      this.createAccountBtnLoading = false
      this.checkAccountBtnLoading = false
      this.createReportRequestBtnLoading = false
      this.btnDownloadLoading = false
      this.createReportBtnLoading = false
      this.e1 = 1
    },
    resetSelection () {
      this.reportrequest = {
        report_data: []
      }
      this.items = []
      this.selected = []
      clearInterval(this.pollingReportRequestList)
      this.e1 = 3
    },
    createAccount () {
      this.createAccountBtnLoading = true
      Auth.currentSession().then(async response => {
        let result = await API.graphql({
          query: createAdWordsAccount,
          variables: {input: { client_id: this.clientId }}
        })
        this.account = result.data.createAdWordsAccount
        this.handleAccountStatus()
        this.createAccountBtnLoading = false
      })
    },
    checkAccount() {
      this.checkAccountBtnLoading = true
      this.getAccount()
        .then(result => {
          this.checkAccountBtnLoading = false
        })
    },
    getAccount () {
      return new Promise((resolve, reject) => {
        Auth.currentSession().then(async response => {
          let result = await API.graphql({
            query: getAdWordsAccount,
            variables: {id: this.account.id}
          })
          this.account = result.data.getAdWordsAccount
          this.handleAccountStatus()
            .then(result => {
              resolve()
            })
        })
      })
    },
    handleAccountStatus () {
      return new Promise((resolve, reject) => {
        if (this.account.status === "connected") {
          this.e1 = 3
          // load kpi charts for given account
          this.getKpiReport(this.account.id)
          // load conversion targets for given account
          this.getConversionsReport(this.account.id)
          // load reportrequests for given account
          this.reportRequestsLoading = true
          this.listReportRequests().then(result => {
            this.reportRequestsLoading = false
          })
          resolve()
        } else {
          this.e1 = 2
          resolve()
        }
      })
    },
    async getKpiReport (accountId) {
      return new Promise((resolve, reject) => {
        this.kpiChartsLoading = true
        Auth.currentSession()
          .then(async response => {
            let result = await API.graphql({
              query: getAdWordsAccountKpiReport,
              variables: {
                id: accountId
              }
            })
            const data = JSON.parse(result.data.getAdWordsAccountKpiReport.report)
            const sortedData = data.table.row.sort((a, b) => new Date(a["@month"]) - new Date(b["@month"]))
            sortedData.forEach(function(item) {
              this.dataClicksChart.push(parseInt(item["@clicks"]))
              this.dataCostChart.push(parseFloat(item["@cost"]))
              this.dataConversionsChart.push(parseInt(item["@conversions"]))
              this.dataLabels.push(this.formatChartDate(item["@month"]))
            }, this)
            this.kpiChartsLoading = false
            resolve()
          })
          .catch(error => {
            console.log(error)
            // reject()
          })
      })
    },
    async getConversionsReport (accountId) {
      return new Promise((resolve, reject) => {
        this.conversionsReportLoading = true
        Auth.currentSession()
          .then(async response => {
            let result = await API.graphql({
              query: getAdWordsAccountConversionsReport,
              variables: {
                id: accountId }
            })
            const data = JSON.parse(result.data.getAdWordsAccountConversionsReport.report)
            this.dataLabelConversions = data.table.columns.column
            this.dataConversions = data.table.row
            this.conversionsReportLoading = false
            resolve()
          })
          .catch(error => {
            console.log(error)
            // reject()
          })
      })
    },
    formatTimeRangeDate(dateStr) {
      let year = dateStr.substring(0, 4)
      let month = dateStr.substring(4, 6)
      let day = dateStr.substring(6, 8)
      console.log(`${year}-${month}-${day}`)
      const d = new Date(`${year}-${month}-${day}`)
      const dtf = new Intl.DateTimeFormat('de', { year: 'numeric', month: '2-digit', day: '2-digit' })
      const [{ value: da },,{ value: mo },,{ value: ye }] = dtf.formatToParts(d)
      return `${da}.${mo}.${ye}`
    },
    formatDate(dateStr) {
      const d = new Date(dateStr)
      const dtf = new Intl.DateTimeFormat('de', { year: 'numeric', month: 'long', day: '2-digit' })
      const [{ value: da },,{ value: mo },,{ value: ye }] = dtf.formatToParts(d)
      return `${da} ${mo} ${ye}`
    },
    formatStartDate () {
      return this.fromDateVal.substring(0, 4) + this.fromDateVal.substring(5, 7) + '01'
    },
    formatEndDate () {
      let year = this.toDateVal.substring(0, 4)
      let month = this.toDateVal.substring(5, 7)
      return year + month + this.getLastDayOfMonth(year, month)
    },
    formatChartDate (dateStr) {
      const d = new Date(dateStr)
      const dtf = new Intl.DateTimeFormat('de', { year: '2-digit', month: 'short', day: '2-digit' })
      const [{ value: da },,{ value: mo },,{ value: ye }] = dtf.formatToParts(d)
      return `${mo} '${ye}`
    },
    reportRequestIcon (status) {
      if (status === 'completed') {
        return 'check_circle'
      } else if (status === 'failed') {
        return 'error'
      } else if (status === 'processing') {
        return 'build'
      } else if (status === 'pending') {
        return 'watch_later'
      }
    },
    listReportRequests() {
      return new Promise((resolve) => {
        Auth.currentSession().then(async response => {
          let result = await API.graphql({
            query: listAdWordsReportRequests,
            variables: {
              filter: {
                account_id: {
                  eq: this.account.id
                }
              }
            }
          },
          )
          this.reportrequests = result.data.listAdWordsReportRequests.items
          resolve()
        })
      })
    },
    showReportRequest( requestId ) {
      clearInterval(this.pollingReportRequestList)
      this.getReportRequest(requestId, this.options.itemPerPage, this.getSort())
      this.e1 = 4
    },
    async newReportRequest () {
      await this.createReportRequest()
      // start polling of state
      // this.pollReportStatus( this.reportrequest.id )
      this.pollReportRequestsList()
    },
    createReportRequest () {
      return new Promise((resolve) => {
        this.createReportRequestBtnLoading = true
        Auth.currentSession().then(async response => {
          let result = await API.graphql({
            query: createAdWordsReportRequest,
            variables: {
              input: {
                account_id: this.account.id,
                start: this.formatStartDate(),
                end: this.formatEndDate(),
                report_type: this.reportType
              }
            }
          },
          )
          // add to list
          this.reportrequest = result.data.createAdWordsReportRequest
          this.reportrequests.push(this.reportrequest)
          // if (this.reportrequest.status === 'pending') {
          //   this.reportrequest.status = 'processing'
          //   let newReportRequest = this.reportrequest
          //   this.reportrequests.push(newReportRequest)
          // }
          this.createReportRequestBtnLoading = false
          resolve()
        })
      })
    },
    isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false
      }
      return true
    },
    getReportRequest (requestId, limit=25, sort) {
      return new Promise((resolve, reject) => {
        this.tableLoading = true
        Auth.currentSession()
          .then(async response => {
            let variables = {
              id: requestId, // this.reportrequest.id,
              account_id: this.account.id,
              limit: limit
            }
            if (!this.isEmpty(sort)) {
              variables.sort = sort
            }
            let result = await API.graphql({
              query: getAdWordsReportRequest,
              variables: variables
            })
            this.reportrequest = result.data.getAdWordsReportRequest
            // Update data
            if (this.reportrequest.report_data) {
              this.items = this.reportrequest.report_data
            }
            this.tableLoading = false
            // this.handleReportRequestStatus()
            resolve()
          })
          .catch( error => {
            reject()
          })
      })
    },
    // handleReportRequestStatus () {
    //   if (this.reportrequest.status === "completed") {
    //     clearInterval(this.pollingReportStatus)
    //   }
    // },
    pollReportRequestsList () {
      this.pollingReportRequestList = this.startInterval(5, () => {
        this.listReportRequests()
        // if status of all reportrequests is failed or complete => clearInterval
        const done = this.reportrequests.every((item) => {
          return item.status !== 'pending' && item.status !== 'processing'
        })
        if (done) {
          console.log('done! clearInterval...')
          clearInterval(this.pollingReportRequestList)
        }
      })
    },
    // pollReportStatus ( requestId ) {
    //   this.pollingReportStatus[requestId] = this.startInterval(5, async () => {
    //     await this.getReportRequest(this.reportrequest.id, this.options.itemPerPage, this.getSort())

    //   })
    // },
    startInterval(seconds, callback) {
      callback()
      return setInterval(callback, seconds * 1000)
    },
    getReport (id) {
      // direkter http request mit token?
      return new Promise((resolve, reject) => {
        Auth.currentSession().then(async response => {
          let apiName = 'adwords-rest-api-' + this.$env
          let path = '/v1/accounts/'+this.account.id+'/reportrequests/'+this.reportrequest.id+'/report/'+id
          let init = {
            responseType: 'blob',
            headers: {
              Accept: "application/pdf", // needs to be set explicitly, otherwise api-gateway returns no binary data
              Authorization: response.getIdToken().getJwtToken()
            }
          }
          API.get(apiName, path, init)
            .then(response => {
              var link=document.createElement('a')
              link.href=window.URL.createObjectURL(response)
              link.download="golden_nugget_report_" + id + ".pdf"
              link.click()
              // this.btnDownloadLoading = false
              resolve()
            })
            .catch(error => {
              console.log(error)
              reject()
            })
        })
      })
    },
    getSort() {
      let sort = {}
      this.options.sortBy.forEach(function(item, index) {
        if (this.options.sortDesc[index] === true) {
          sort[item] = 'DESC'
        } else if (this.options.sortDesc[index] === false) {
          sort[item] = 'ASC'
        }
      }, this)
      return sort
    },
    onSort (event) {
      this.getReportRequest(this.reportrequest.id, this.options.itemPerPage, this.getSort())
    },
    onDownload (event) {
      // this.btnDownloadLoading = true
      // this.selected.forEach(function(item) {
      //   this.getReport(item.id)
      // }, this)
      console.log(this.selected)
      this.e1 = 5
    },
    createReport () {
      return new Promise((resolve) => {
        this.createReportBtnLoading = true
        let reportIds = []
        this.selected.forEach(function(item) {
          reportIds.push(item.id)
        }, this)
        this.getReport(reportIds.join())
          .then(result => {
            this.createReportBtnLoading = false
            resolve()
          })
      })
    },
  },
  beforeDestroy () {
    // clearInterval(this.pollingReportStatus)
    clearInterval(this.pollingReportRequestList)
  },
  created () {
    this.setPage(this.pageTitle)
  },
  i18n: {
    messages: {
      de: {
        steps: {
          one: {
            title: "Account Id"
          },
          two: {
            title: "Account Status",
            connected: "verknüpft",
            not_connected: "nicht verknüpft"
          },
          three: {
            title: "Auswertungen"
          },
          four: {
            title: "Auswahl"
          },
          five: {
            title: "Sortieren / Download"
          },
        }
      },
      en: {
        save: 'Save'
      },
    },
  },
}

</script>

<style scoped>
  .sortable {
    cursor: grab;
  }
  .sortable-drag {
    opacity: 0;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .ghost {
    border-left: 6px solid #50AA3C;
    -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  }
</style>
